import React from 'react'

import { FullStoryScriptLazyInit } from '../../lib/tracking/fullstory'
import { GtmNoScript, GtmScript } from '../../lib/tracking/google-tag-manager'
import { OneTrustScripts } from '../../lib/tracking/onetrust'
import { AirGapScript } from '../../lib/tracking/transcend/AirGapScript'
import { GoogleOneTapScript } from '../google-one-tap/script'
import { WebHeartbeatScript } from '../../lib/tracking/web-heartbeat'
import { SprigScript } from '../../lib/tracking/sprig'

interface CmsPageScriptsProps {
  isPreview?: boolean
  showGoogleOneTap?: boolean
  enableFullStory?: boolean
  enableOneTrust?: boolean
  enableGtmIntegration?: boolean
  enableWebHeartbeat?: boolean
  enableAirGap?: boolean
  enableSprig?: boolean
}

export const CmsPageScripts: React.FC<CmsPageScriptsProps> = (props) => {
  const {
    isPreview,
    showGoogleOneTap,
    enableFullStory,
    enableOneTrust,
    enableGtmIntegration,
    enableWebHeartbeat,
    enableAirGap,
    enableSprig,
  } = props

  if (isPreview) {
    return null
  }

  return (
    <>
      {enableOneTrust && <OneTrustScripts />}
      {enableAirGap && <AirGapScript />}
      {showGoogleOneTap && <GoogleOneTapScript />}
      {enableGtmIntegration && <GtmScript />}
      {enableGtmIntegration && <GtmNoScript />}
      {enableFullStory && <FullStoryScriptLazyInit />}
      {enableSprig && <SprigScript />}
      {enableWebHeartbeat && <WebHeartbeatScript />}
    </>
  )
}
